
import {signal} from "@e280/strata"

export class Progress {
	fraction = signal(0)
}

